import { type RefObject, useEffect, useState } from 'react'

interface UseDynamicInputSizeProps {
  containerRef?: RefObject<HTMLDivElement | null>
  inputValue: string
  scaleFactor?: number
  maxFontSize?: number
  defaultFontSize?: number
}

export const useDynamicInputSize = ({
  containerRef,
  inputValue,
  scaleFactor = 1.65,
  maxFontSize = 48,
}: UseDynamicInputSizeProps) => {
  const [fontSize, setFontSize] = useState(`${maxFontSize}px`)

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally omitting dependencies to avoid infinite re-renders
  useEffect(() => {
    if (!containerRef?.current) return
    const containerWidth = containerRef.current?.offsetWidth || 0
    const calculatedSize = Math.max(
      (containerWidth / (inputValue.length || 1)) * scaleFactor,
      16,
    )
    setFontSize(`${Math.min(calculatedSize, maxFontSize)}px`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return { fontSize }
}
